export default function SEOContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="about">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-start">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-5">
              What Is the Sugargoo Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                The <strong>Sugargoo Spreadsheet</strong> is a meticulously organized database of product listings, designed specifically for international shoppers who use the Sugargoo platform. Think of it as your personal shopping assistant &mdash; a comprehensive catalog that helps you discover trending fashion items, sneakers, accessories, and lifestyle products all in one neatly structured document.
              </p>
              <p>
                Unlike browsing through endless pages on traditional e-commerce sites, the <strong>Sugargoo Spreadsheet</strong> categorizes thousands of products into easy-to-navigate sections. Whether you are hunting for the latest sneaker releases, premium hoodies, luxury bags, or budget-friendly accessories, the spreadsheet simplifies your discovery process dramatically.
              </p>
              <p>
                What makes the <strong>Sugargoo Spreadsheet</strong> truly valuable is the community-driven curation behind it. Experienced Sugargoo users contribute their finds, share QC (Quality Control) photo references, and update listings regularly to ensure you always have access to fresh, high-quality product links. This collaborative approach means the spreadsheet evolves continuously, reflecting the latest trends and most reliable seller recommendations.
              </p>
            </div>

            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-8 mb-4">
              Why Thousands of Shoppers Trust the Sugargoo Spreadsheet
            </h3>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                In the world of international shopping, trust and reliability are everything. The <strong>Sugargoo Spreadsheet</strong> has earned its reputation as the go-to resource because it puts verified information at your fingertips. Every product listing includes direct links, estimated pricing ranges, and community feedback &mdash; so you never have to guess whether a seller is legitimate or a product matches its description.
              </p>
              <p>
                For beginners especially, the <strong>Sugargoo Spreadsheet</strong> acts as a gentle introduction to the Sugargoo ecosystem. Instead of feeling overwhelmed by the platform&apos;s many features and options, new users can simply browse the spreadsheet, find items they love, and follow straightforward links to start shopping immediately. It removes the intimidation factor and makes international shopping accessible to everyone.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="sticky top-24">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20visually%20striking%20organized%20product%20catalog%20layout%20with%20fashion%20accessories%20bags%20and%20sneakers%20artistically%20displayed%20on%20floating%20minimalist%20shelves%2C%20warm%20diffused%20gallery%20lighting%20creating%20soft%20elegant%20shadows%2C%20refined%20boutique%20aesthetic%2C%20harmonious%20blend%20of%20taupe%20cream%20and%20soft%20olive%20tones%2C%20premium%20lifestyle%20editorial%20photography%2C%20sophisticated%20and%20inviting%20retail%20atmosphere&width=800&height=1000&seq=sugargoo-content-v2&orientation=portrait"
                  alt="Organized Sugargoo Spreadsheet product catalog with curated fashion items"
                  title="Sugargoo Spreadsheet Product Organization"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="mt-6 p-5 bg-accent-50 rounded-xl border border-accent-200/60">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-200 text-accent-700 mt-0.5">
                    <i className="ri-lightbulb-line text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                      Did You Know?
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      The Sugargoo Spreadsheet is updated weekly with new finds, ensuring you always have access to the freshest product discoveries. Categories range from budget finds under $20 to premium luxury items.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}